import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssociateCandidatesActionsModalComponent } from './associate-candidates-actions-modal.component';
import { OverrideCandidateSuspensionModule } from 'src/app/shared/override-candidate-suspension/override-candidate-suspension.module';

@NgModule({
  declarations: [AssociateCandidatesActionsModalComponent],
  imports: [
    CommonModule,
    OverrideCandidateSuspensionModule
  ],
  exports: [AssociateCandidatesActionsModalComponent],
  entryComponents: [AssociateCandidatesActionsModalComponent]
})
export class AssociateCandidatesActionsModalModule { }
